import { Stethoscope, ClipboardList, ShieldCheck, Building2, IndianRupee } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const points = [
  { icon: Stethoscope, title: "Doctor-led aesthetic care" },
  { icon: ClipboardList, title: "Personalised treatment plans" },
  { icon: ShieldCheck, title: "Focus on safety and skin health" },
  { icon: Building2, title: "Professional clinical environment" },
  { icon: IndianRupee, title: "Transparent pricing" },
];

export const Trust = () => (
  <section data-testid="trust-section" className="py-24 md:py-36 bg-sand/50 border-y border-champagne/40">
    <div className="max-w-7xl mx-auto px-5 md:px-10">
      <SectionHead index="11" eyebrow="Trust" title="Why Krystal Skin And Laser Clinic?" align="center" />
      <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
        {points.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.07}>
            <div
              data-testid={`trust-point-${i + 1}`}
              className="group h-full flex flex-col items-center text-center rounded-3xl border border-champagne/60 bg-white/70 px-5 py-10 transition-[background-color,transform] duration-500 hover:-translate-y-1.5 hover:bg-white"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-teal/10 transition-colors duration-500 group-hover:bg-teal">
                <p.icon className="w-5 h-5 text-teal transition-colors duration-500 group-hover:text-champagne-light" strokeWidth={1.5} />
              </span>
              <p className="mt-5 text-sm font-medium leading-snug text-ink/80">{p.title}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
